<template>
<footer></footer>
</template>
<script>
export default {
  name: "Footer"
};
</script>
<style lang="sass" scoped>
footer
  padding: 0 20px
  line-height: 30px
  box-sizing: border-box
</style>


// WEBPACK FOOTER //
// src/vms/pages/layout/Footer.vue